import { PRODUCTS_PER_PAGE } from 'api/constants';
import { TPhoneCasesGetListQueryParams } from 'api/phoneCases/phoneCases.types';
import {
  EProductsFiltersDrawerBlockType,
  TProductsFiltersDrawerBlock,
} from 'components';
import { PHONE_CASES_CATEGORIES_MENU_CONFIG } from 'constants/categoriesMenu';

export const PHONE_CASES_FILTERS: TProductsFiltersDrawerBlock[] = [
  {
    id: 'price',
    blockTitle: 'products.filters.price',
    blockType: EProductsFiltersDrawerBlockType.RangeSlider,
    blockProps: {
      id: 'price',
      label: 'products.filters.price',
      minPrice: 0,
      maxPrice: 1000,
    },
    initialValue: [0, 1000],
  },
];

export { PHONE_CASES_CATEGORIES_MENU_CONFIG };

export const PHONE_CASES_DEFAULT_QUERY_PARAMS: TPhoneCasesGetListQueryParams = {
  page: 1,
  perPage: PRODUCTS_PER_PAGE,
};
